import React, { useEffect, useState } from "react";
import { useStytchUser } from "@stytch/react";
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from "@/lib/components/ui/avatar";

const UserAvatar = () => {
  const { user } = useStytchUser();

  const [userLogo, setUserLogo] = useState<string>();

  useEffect(() => {
    const getUserLogo = async () => {
      if (!user) return;

      const foundLogo = user.providers.find(
        provider => provider.profile_picture_url.length > 0,
      )?.profile_picture_url;

      setUserLogo(foundLogo);
    };

    getUserLogo();
  }, [user]);

  return (
    <Avatar className="h-8 w-8 rounded-md">
      <AvatarImage src={userLogo ?? ""} alt={user?.name.first_name ?? ""} />
      <AvatarFallback>{user?.name?.first_name?.[0]}</AvatarFallback>
    </Avatar>
  );
};

export default UserAvatar;
